import { StateUpdatedEvent } from 'ag-grid-community';

import { InitialConstraints } from './types';

export const checkConstraintsUpdate = (event: StateUpdatedEvent) => {
  const isInitialEvent = event.sources.includes('gridInitializing');
  if (isInitialEvent) return false;

  const hasReasonToUpdate = event.sources.some((source) => {
    return ['sort', 'filter', 'pagination'].includes(source);
  });

  return hasReasonToUpdate;
};

export const extractConstraints = (
  event: StateUpdatedEvent,
): InitialConstraints => {
  const agSort = event.state.sort?.sortModel || [];
  const agFilter = event.state?.filter?.filterModel || {};
  const agPagination = event.state.pagination;

  const constraints: InitialConstraints = {
    sort: agSort,
    filter: agFilter,
    pagination: agPagination,
  };

  return constraints;
};
